module.exports = __webpack_public_path__ + "img/icon-search.0966280e.svg";